import config from 'src/config'

/**
 * Build the stable proxy URL for a venue-uploaded product photo stored in S3.
 * Mirrors the server's /files/:keyName pattern used for recipe images.
 */
export const buildCustomImageUrl = keyName => {
  const baseUrl = config.apiGateway.EXPRESS_URL
  if (!keyName || !baseUrl) return null
  return `${baseUrl}files/${encodeURIComponent(keyName)}`
}

/**
 * Resolve the venue's own photo URL for a venueProduct, if any.
 * Returns null when the venue has no custom photo (caller falls back to
 * the supplier's cloudinaryImageId / placeholder).
 */
export const getVenueCustomImageUrl = venueProduct =>
  venueProduct?.customImageUrl ||
  buildCustomImageUrl(venueProduct?.customImage?.keyName) ||
  null
